module.exports = __webpack_public_path__ + "static/img/pdf.113b294.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/pdf.png
// module id = S/fU
// module chunks = 1